import { AuthProvider, fetchUtils } from "react-admin";
import { jwtDecode } from "jwt-decode";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}`;
const httpClient = fetchUtils.fetchJson;

const authProvider: AuthProvider = {
  login: ({ username, password }: any) => {
    const request = new Request(`${apiUrl}/auth/login`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ access_token }) => {
        localStorage.setItem('token', access_token);
        const decodedToken: { username: string, sub: number } = jwtDecode(access_token);
        localStorage.setItem('username', JSON.stringify(decodedToken.username));
        // return { redirectTo: false };
      });
  },
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    return Promise.resolve();
  },
  checkAuth: (params: any) => {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
  },
  checkError: (error: any) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  getPermissions: () => {
    return Promise.resolve('');
    // const roles = localStorage.getItem('roles');
    // return roles ? Promise.resolve(JSON.parse(roles)) : Promise.reject();
  },
  getIdentity: () =>  {
    const username = localStorage.getItem('username');
    return username
      ? Promise.resolve({ id: username, fullName: username })
      : Promise.reject();
  },
};

export default authProvider;
